"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heap = void 0;
class Heap {
    items;
    compare;
    constructor(compare) {
        this.items = [];
        this.compare = compare;
    }
    push(item) {
        const index = this.getItemIndex(item);
        this.items.splice(index, 0, item);
    }
    pop() {
        return this.items.shift();
    }
    peek() {
        if (!this.isEmpty()) {
            return this.items[0];
        }
        else {
            return undefined;
        }
    }
    contains(item) {
        if (!this.isEmpty()) {
            const index = this.getItemIndex(item);
            if (index !== this.items.length) {
                return this.compare(this.items[index], item) === 0;
            }
        }
        return false;
    }
    isEmpty() {
        return this.items.length === 0;
    }
    values() {
        return this.items;
    }
    /*
     * Return the index at which the item can be inserted in order to maintain
     * the sort order of the array. If the item is in the array, it can be found
     * at the returned index.
     */
    getItemIndex(item) {
        if (!this.isEmpty()) {
            let first = 0;
            let last = this.items.length;
            while (first < last) {
                const middle = Math.floor((first + last) / 2);
                const comparison = this.compare(this.items[middle], item);
                if (comparison < 0) {
                    first = middle + 1;
                }
                else {
                    last = middle;
                }
            }
            return last;
        }
        else {
            return 0;
        }
    }
}
exports.Heap = Heap;
//# sourceMappingURL=Heap.js.map